import { Component, OnInit, ViewChild, NgZone, HostListener } from '@angular/core';
import { Language } from 'src/core/utility/enums/enums';
import { TranslateService } from '@ngx-translate/core';
import { BaseTranslation } from 'src/core/translation/model/translation.base';
import { CarouselComponent } from 'ngx-owl-carousel-o';
import { ContactUsComponent } from './contact-us/contact-us.component';


@Component({
  selector: 'adahi-home',
  templateUrl: './home.component.html'
})
export class HomeComponent extends BaseTranslation implements OnInit {
  @ViewChild('owlCar') owlCar: CarouselComponent;
  @ViewChild('contactus') ContactUsComponent: ContactUsComponent;

  mobileView: boolean = false;
  resizeFlag: boolean = true;
  introduction: string = '';
  aboutProject: string = '';
  isdb: string = '';
  news: string = '';
  contactUs: string = '';
  idOne = '1';
  idTwo = '2';
  idThree = '3';
  idFour = '4';
  idFive = '5';
  carouselData = [
    { id: 'slide-1' },
    { id: 'slide-2' },
    { id: 'slide-3' },
    { id: 'slide-4' },
    { id: 'slide-5' }
  ];
  carouselcustomOptions: any;
  introductionDotContent;
  aboutProjectDotContent;
  isdbDotContent;
  newsDotContent;
  contactUsDotContent;

  constructor(translateService: TranslateService, ngZone: NgZone) {
    super(translateService, ngZone);

    this.translate.get(['home.introduction.introduction', 'home.about-project.aboutProject', 'home.isdb.isdb', 'home.contact-us.contactUs', 'news.newsHomePageTitle']).subscribe((res) => {
      this.introduction = res["home.introduction.introduction"];
      this.aboutProject = res["home.about-project.aboutProject"];
      this.isdb = res["home.isdb.isdb"];
      this.news = res["news.newsHomePageTitle"];
      this.contactUs = res["home.contact-us.contactUs"];

    });

    this.carouselOptions();

  }

  @HostListener('window:resize')
  onResize() {

    if (window.innerWidth < 1200) {

      if (!this.mobileView) {
        this.ngZone.run(() => {
          this.mobileView = true;
        });
      }

    } else {

      if (this.mobileView) {
        this.ngZone.run(() => {
          this.mobileView = false;
        });
      }

      //Resize Flag
      this.ngZone.run(() => {
        this.resizeFlag = false;
      });
      this.ngZone.run(() => {
        this.resizeFlag = true;
      });
    }

    if (!this.mobileView) { //Desktop

      var homeOwlItems = document.querySelectorAll('#project-news *');
      homeOwlItems.forEach(function (homeOwlItem) {
        homeOwlItem.setAttribute('tabindex', '-1');
      });

      var homeOwlItems2 = document.querySelectorAll('#contact-us *');
      homeOwlItems2.forEach(function (homeOwlItem2) {
        homeOwlItem2.setAttribute('tabindex', '-1');
      });

    }
  }

  ngOnInit() {
    if (window.innerWidth < 1200) {
      if (!this.mobileView) {
        this.mobileView = true;
      }
    } else {
      if (this.mobileView) {
        this.mobileView = false;
      }
    }
  }

  carouselOptions() {
    if (Language[_spPageContextInfo.currentLanguage] == 'ar') {
      this.carouselcustomOptions = {
        rtl: true,
        loop: false,
        items: 1,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        dotsData: true,
        autoplay: false,
        autoplayTimeout: 99999999,
        autoWidth: true,
        responsive: {
          0: {
            items: 1
          }
        }
      }
    } else {
      this.carouselcustomOptions = {
        loop: false,
        items: 1,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        dotsData: true,
        autoplay: false,
        autoplayTimeout: 99999999,
        autoWidth: true,
        responsive: {
          0: {
            items: 1
          }
        }
      }
    }
  }

}